import { render, staticRenderFns } from "./AuditlogList.vue?vue&type=template&id=410326ac"
import script from "./AuditlogList.vue?vue&type=script&lang=js"
export * from "./AuditlogList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports